/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateRangeValue
 */
export interface DateRangeValue {
}

/**
 * Check if a given object implements the DateRangeValue interface.
 */
export function instanceOfDateRangeValue(value: object): value is DateRangeValue {
    return true;
}

export function DateRangeValueFromJSON(json: any): DateRangeValue {
    return DateRangeValueFromJSONTyped(json, false);
}

export function DateRangeValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateRangeValue {
    return json;
}

export function DateRangeValueToJSON(json: any): DateRangeValue {
    return DateRangeValueToJSONTyped(json, false);
}

export function DateRangeValueToJSONTyped(value?: DateRangeValue | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

